import { useRef } from 'react';
import { useParams } from 'react-router-dom';

import { observer } from 'mobx-react-lite';
import styled from 'styled-components';
import { ThemeProvider } from 'styled-components';

import useQueryParams from '@hooks/use-query-params';
import { getVisibleHeight } from '@utils/browser';

import CompanyBanner from 'components/CompanyBanner';
import CompanyListingContainer from 'components/CompanyListingContainer';
import CompanyLogoHeader from 'components/CompanyLogoHeader';
import CompanyOpeningsHeader from 'components/CompanyOpeningsHeader';
import CookieConsent from 'components/CookieConsent';
import CoreThemeBridge from 'components/CoreThemeBridge';
import FiftyFooter from 'components/FiftyFooter';
import { useStore } from 'models/stores';

import LanguageSwitcher from './LanguageSwitcher';
import MainContent from './MainContent';

function App({ lang }) {
  const { companyStore, jobStore, uiStore } = useStore();
  const bannerRef = useRef();
  const mainRef = useRef();
  const { name } = useParams();

  const company = companyStore.current || {};
  const { logo = '', banner = '', url = '', logoHeight } = company;

  companyStore.setCurrent(name);
  jobStore.setCurrent(name);
  uiStore.setLanguage(lang);

  const frame = useQueryParams('frame');

  return (
    <ThemeProvider theme={uiStore.theme.toJSON()}>
      <CoreThemeBridge>
        {frame ? (
          <StyledContainer>
            <MainContent ref={mainRef} key={uiStore.language} />
          </StyledContainer>
        ) : (
          <HomePage minHeight={getVisibleHeight()}>
            <LanguageSwitcher />
            <CompanyLogoHeader logo={logo} url={url} height={logoHeight} />
            <CompanyBanner imgUrl={banner} ref={bannerRef} />
            <CompanyListingContainer>
              <CompanyOpeningsHeader mainRef={mainRef} bannerRef={bannerRef} id="main-header" />
              <MainContent ref={mainRef} key={uiStore.language} />
              <FiftyFooter lang={uiStore.language} />
            </CompanyListingContainer>
            <CookieConsent site="careers" lang={uiStore.language} />
          </HomePage>
        )}
      </CoreThemeBridge>
    </ThemeProvider>
  );
}
export default observer(App);

const StyledContainer = styled.div`
  background-color: ${(p) => p.theme.pageBackgroundColor};
`;

const HomePage = styled.div`
  background-color: ${(p) => p.theme.backgroundPrimary};
  min-height: ${(p) => p.minHeight + 'px'};
  display: flex;
  flex-direction: column;
  position: relative;
  flex-grow: 1;
`;
